/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VwbDataCollectionEntry } from './VwbDataCollectionEntry';
import {
    VwbDataCollectionEntryFromJSON,
    VwbDataCollectionEntryFromJSONTyped,
    VwbDataCollectionEntryToJSON,
} from './VwbDataCollectionEntry';

/**
 * 
 * @export
 * @interface VwbDataCollectionListResponse
 */
export interface VwbDataCollectionListResponse {
    /**
     * 
     * @type {Array<VwbDataCollectionEntry>}
     * @memberof VwbDataCollectionListResponse
     */
    items: Array<VwbDataCollectionEntry>;
}

/**
 * Check if a given object implements the VwbDataCollectionListResponse interface.
 */
export function instanceOfVwbDataCollectionListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function VwbDataCollectionListResponseFromJSON(json: any): VwbDataCollectionListResponse {
    return VwbDataCollectionListResponseFromJSONTyped(json, false);
}

export function VwbDataCollectionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbDataCollectionListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(VwbDataCollectionEntryFromJSON)),
    };
}

export function VwbDataCollectionListResponseToJSON(value?: VwbDataCollectionListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(VwbDataCollectionEntryToJSON)),
    };
}

